import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddTypesOfFertilizersMutation, useDeleteTypesOfFertilizersMutation, useEditTypesOfFertilizersMutation
} from "../../../../../redux/api/handBooksApi/chemicalization/typesOfFertilizersApi";
import { EntTypesOfFertilizers } from "../../../../../models/handBooks/typesOfFertilizers";



const useTypesOfFertilizers = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addTypesOfFertilizers] = useAddTypesOfFertilizersMutation();
  const [deleteTypesOfFertilizers] = useDeleteTypesOfFertilizersMutation();
  const [editTypesOfFertilizers] = useEditTypesOfFertilizersMutation();


  async function onAddTypesOfFertilizers(newTypesOfFertilizers: EntTypesOfFertilizers): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addTypesOfFertilizers(newTypesOfFertilizers).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if(refresh) refresh();
		}
	  }).catch((error:any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteTypesOfFertilizers(typesOfFertilizers: EntTypesOfFertilizers) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteTypesOfFertilizers(typesOfFertilizers.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({title: t('msg.successDelete')});
			  if(refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  async function onEditTypesOfFertilizers(editedTypesOfFertilizers: EntTypesOfFertilizers): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editTypesOfFertilizers(editedTypesOfFertilizers).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({title: t('msg.successEdited')});
		  if(refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }
  return { onAddTypesOfFertilizers,onDeleteTypesOfFertilizers, onEditTypesOfFertilizers }

}
export { useTypesOfFertilizers };

